module.exports = __webpack_public_path__ + "static/media/rasmal.73e87ac8.png";